<template>
	<div class="head">
		<div class="head_left">
			<div @click="toback" class="head_left_item">
				<img class="head_left_arrow" src="@/assets/returnpage.png" alt="" />
				<strong>返回</strong>
			</div>
			<div class="head_left_item head_left_active">
				<img class="head_left_arrow" src="@/assets/zhuangxiu.png" alt="" />
				<strong>装修页面</strong>
			</div>
		</div>
		<div class="head_right">
			<div @click="handelClickItem('page')" class="head_left_item  ">
				<img class="head_left_arrow" src="@/assets/setimg.png" alt="" />
				<strong>页面设置</strong>
			</div>
			<div @click="canvasFn" class="head_right_but">
				<span>保存</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			handelClickItem(index) {
				this.$emit("onEditer", index);
			},
			canvasFn(){
				this.$emit('canvasFn')
			},
			toback(){
				let _this = this
				_this.$confirmDialog({
					title: "确定离开？",
					content: '<div style="font-size:16px;display:flex;align-items: center;justify-content: center;">如果您离开当前页面，未保存的修改可能会丢失</div>',
					cancelText: "取消",
					confirmText: "确定",
					showClose: true,
					width: "400px",
					success: (res) => {
						if (res.confirm) {
							_this.$router.go(-1);
						}
					},
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.head{
		height:58px;
		width:100%;
		background:#1f2227;
		display:flex;
		align-items: center;
		justify-content: space-between;
		padding-left: 20px;
		padding-right: 20px;
		&_left{
			display:flex;
			align-items: center;
			&_item{
				display:flex;
				align-items: center;
				color: #fff;
				padding: 0 20px;
				cursor: pointer;
				height:58px;
				margin-right: 10px;
			}
			&_active{
				background-color:#292e33;
			}
			&_arrow{
				width: 17px;
				height: 17px;
				display: block;
				margin-right: 5px;
			}
		}
		&_right{
			margin-right: 20px;
			display:flex;
			align-items: center;
			&_but{
				color: #fff;
				height: 32px;
				border-radius: 2px;
				background-color: #006aff;
				width:81px;
				display:flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				line-height: 32px;
				font-weight: bold;
				font-size: 14px;
				cursor: pointer;
			}
			&_icon{
				height: 14px;
				width:14px;margin-right:2px
			}
		}
	}
</style>